import { Link } from "react-router-dom";
import cleantech_logo from "../../assets/png/cleantec_logo.png";

function AuthTitle() {
  return (
    <div className="sticky top-0 z-10 flex items-center gap-2.5 bg-[#E7F5FF] px-12 py-6">
      <Link to="/auth" className="flex w-full items-center justify-center">
        <img
          src={cleantech_logo}
          alt="logo"
          className="max-h-16 object-contain"
        />
      </Link>
      {/* <p className="m-0 text-4xl font-semibold">MyWorkApp</p> */}
    </div>
  );
}

export default AuthTitle;
